import { makeStyles } from '@material-ui/core/styles'
import { Theme, Typography, Grid, Link } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { FormattedMessage } from 'react-intl'
import {
  SemiConfigFormValues,
  specificationItem,
  PhysicalMaterialTypes,
} from '../ProductsConfiguration'
import SpecificationRadio from './SpecificationRadio'
import SpecificationSelect from './SpecificationSelect'

const useStyles = makeStyles((theme: Theme) => ({
  specificationItem: {
    paddingTop: theme.spacing(4),
  },
  recommendation: {
    padding: theme.spacing(1, 0, 2),
  },
  infoMessage: {
    padding: theme.spacing(2, 0),
  },
}))
interface VirusSpecificationsProps {
  lentivirusBackboneList: specificationItem[]
  titerList: specificationItem[]
  volumeList: specificationItem[]
  aliquotList: specificationItem[]
  onChange: (f: string, v: string) => void
}

const VirusSpecifications = ({
  lentivirusBackboneList,
  titerList,
  volumeList,
  aliquotList,
  onChange,
}: VirusSpecificationsProps) => {
  const classes = useStyles()
  const formik = useFormikContext<SemiConfigFormValues>()

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="h3">
          *
          <FormattedMessage
            id="CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna"
            defaultMessage="Lentivirus Backbone"
          />
        </Typography>
      </Grid>
      {formik.values.specifications.physicalMaterial ===
        PhysicalMaterialTypes.VIRUS && (
        <Grid item xs={12} className={classes.recommendation}>
          <FormattedMessage
            id="CONF_DNA_DROPDOWN_SPECIFICATION_crispgrna"
            defaultMessage="View vector maps and features at"
          />
          <Link
            href="/technical-documents/technical-article/genomics/advanced-gene-editing/crispr-clone-control-and-cas9-essentials"
            underline="hover"
            target="_blank"
          >
            <span>
              <FormattedMessage
                id="CONF_DNA_LINK_SPECIFICATION_shrna"
                defaultMessage=" Vector Maps "
              />
            </span>
          </Link>
        </Grid>
      )}

      <SpecificationSelect
        list={lentivirusBackboneList}
        fieldName="lentivirusBackbone"
        specificationLabel={
          <FormattedMessage
            id="CONF_VIRUS_LENTIVIRUS_SPECIFICATION_crispgrna"
            defaultMessage="Lentivirus Backbone"
          />
        }
        specificationValue={formik.values.specifications.lentivirusBackbone}
        handleChange={onChange}
        showRequiredError
        fitContent
      />

      <Grid item xs={12} className={classes.specificationItem}>
        <Typography variant="h3">
          *
          <FormattedMessage
            id="CONF_VIRUS_TITER_SPECIFICATION_crispgrna"
            defaultMessage="Titer"
          />
        </Typography>
        <Typography variant="body2" className={classes.infoMessage}>
          <FormattedMessage
            id="SEMICONF_HELP_ICON_TEXT_TITER_crisprgrna"
            defaultMessage="The concentration of lentivirus particles, measured by p24 ELISA"
          />
        </Typography>
      </Grid>
      <SpecificationRadio
        list={titerList}
        specificationName="titer"
        specificationValue={formik.values.specifications.titer}
        handleChange={onChange}
        showRequiredError
        hasInfo
      />
      {formik.values.specifications.titer && (
        <>
          <Grid item xs={12} className={classes.specificationItem}>
            <Typography variant="h3">
              *
              <FormattedMessage
                id="CONF_VIRUS_VOLUME_SPECIFICATION_crispgrna"
                defaultMessage="Volume"
              />
            </Typography>
            <Typography variant="body2" className={classes.infoMessage}>
              <FormattedMessage
                id="SEMICONF_HELP_ICON_TEXT_VOLUME_crisprgrna"
                defaultMessage="The total volume of lentivirus provided"
              />
            </Typography>
          </Grid>
          <SpecificationRadio
            list={volumeList}
            specificationName="volume"
            specificationValue={formik.values.specifications.volume}
            handleChange={onChange}
            showRequiredError
            hasInfo
          />
        </>
      )}
      {formik.values.specifications.volume && (
        <>
          <Grid item xs={12} className={classes.specificationItem}>
            <Typography variant="h3">
              *
              <FormattedMessage
                id="CONF_VIRUS_ALIQUOTING_SPECIFICATION_crispgrna"
                defaultMessage="Aliquoting"
              />
            </Typography>
            <Typography variant="body2" className={classes.infoMessage}>
              <FormattedMessage
                id="SEMICONF_HELP_ICON_TEXT_ALIQUOTING_crisprgrna"
                defaultMessage="The number of vials and aliquot volume in each vial"
              />
            </Typography>
          </Grid>
          <SpecificationRadio
            list={aliquotList}
            specificationName="aliquot"
            specificationValue={formik.values.specifications.aliquot}
            handleChange={onChange}
            showRequiredError
            hasInfo
          />
        </>
      )}
    </Grid>
  )
}

export default VirusSpecifications
